import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7071 9.99982L19.8536 19.1463C20.0488 19.3415 20.0488 19.6581 19.8536 19.8534C19.6583 20.0486 19.3417 20.0486 19.1464 19.8534L10 10.7069L0.853553 19.8534C0.658291 20.0486 0.341709 20.0486 0.146447 19.8534C-0.0488155 19.6581 -0.0488155 19.3415 0.146447 19.1463L9.29289 9.99982L0.146447 0.85337C-0.0488155 0.658108 -0.0488155 0.341525 0.146447 0.146264C0.341709 -0.0489987 0.658291 -0.0489987 0.853553 0.146264L10 9.29271L19.1464 0.146264C19.3417 -0.0489987 19.6583 -0.0489987 19.8536 0.146264C20.0488 0.341525 20.0488 0.658108 19.8536 0.85337L10.7071 9.99982Z"
      />
    </svg>
  );
}
